export default {"src":"/_next/static/media/image404.11cd6c19.svg","height":561,"width":903};